import type { FC } from "react";
import heart from "../../../assetsOld/templates/test/dateAccentHeart.png";
const Date: FC = () => {
  return (
    <div className="flex flex-col items-center">
      <h1 className="gap-[30px] text-center font-primary text-800 font-light leading-[1.2] text-grey-300">
        Когда?
      </h1>
      <h2 className="mb-[30px] mt-10 font-primary text-800 font-light leading-[1.2] text-grey-300">
        Июль
      </h2>
      <div className="pointer-events-none flex w-[320px] select-none flex-wrap gap-x-[24.36px] gap-y-[36px] md:text-900">
        <div className="relative flex w-6 justify-center text-center font-primary text-600 font-normal leading-[1.21] text-grey-300">
          <img
            src={heart}
            alt="<3"
            className={`absolute top-1/2 hidden h-[27.47px] min-w-[31.67px] flex-none -translate-y-1/2 transform`}
          />
          1
        </div>
        <div className="relative flex w-6 justify-center text-center font-primary text-600 font-normal leading-[1.21] text-grey-300">
          <img
            src={heart}
            alt="<3"
            className={`absolute top-1/2 hidden h-[27.47px] min-w-[31.67px] flex-none -translate-y-1/2 transform`}
          />
          2
        </div>
        <div className="relative flex w-6 justify-center text-center font-primary text-600 font-normal leading-[1.21] text-grey-300">
          <img
            src={heart}
            alt="<3"
            className={`absolute top-1/2 hidden h-[27.47px] min-w-[31.67px] flex-none -translate-y-1/2 transform`}
          />
          3
        </div>
        <div className="relative flex w-6 justify-center text-center font-primary text-600 font-normal leading-[1.21] text-grey-300">
          <img
            src={heart}
            alt="<3"
            className={`absolute top-1/2 hidden h-[27.47px] min-w-[31.67px] flex-none -translate-y-1/2 transform`}
          />
          4
        </div>
        <div className="relative flex w-6 justify-center text-center font-primary text-600 font-normal leading-[1.21] text-grey-300">
          <img
            src={heart}
            alt="<3"
            className={`absolute top-1/2 hidden h-[27.47px] min-w-[31.67px] flex-none -translate-y-1/2 transform`}
          />
          5
        </div>
        <div className="relative flex w-6 justify-center text-center font-primary text-600 font-normal leading-[1.21] text-grey-300">
          <img
            src={heart}
            alt="<3"
            className={`absolute top-1/2 hidden h-[27.47px] min-w-[31.67px] flex-none -translate-y-1/2 transform`}
          />
          6
        </div>
        <div className="relative flex w-6 justify-center text-center font-primary text-600 font-normal leading-[1.21] text-grey-300">
          <img
            src={heart}
            alt="<3"
            className={`absolute top-1/2 hidden h-[27.47px] min-w-[31.67px] flex-none -translate-y-1/2 transform`}
          />
          7
        </div>
        <div className="relative flex w-6 justify-center text-center font-primary text-600 font-normal leading-[1.21] text-grey-300">
          <img
            src={heart}
            alt="<3"
            className={`absolute top-1/2 hidden h-[27.47px] min-w-[31.67px] flex-none -translate-y-1/2 transform`}
          />
          8
        </div>
        <div className="relative flex w-6 justify-center text-center font-primary text-600 font-normal leading-[1.21] text-grey-300">
          <img
            src={heart}
            alt="<3"
            className={`absolute top-1/2 h-[27.47px] min-w-[31.67px] flex-none -translate-y-1/2 transform`}
          />
          9
        </div>
        <div className="relative flex w-6 justify-center text-center font-primary text-600 font-normal leading-[1.21] text-grey-300">
          <img
            src={heart}
            alt="<3"
            className={`absolute top-1/2 hidden h-[27.47px] min-w-[31.67px] flex-none -translate-y-1/2 transform`}
          />
          10
        </div>
        <div className="relative flex w-6 justify-center text-center font-primary text-600 font-normal leading-[1.21] text-grey-300">
          <img
            src={heart}
            alt="<3"
            className={`absolute top-1/2 hidden h-[27.47px] min-w-[31.67px] flex-none -translate-y-1/2 transform`}
          />
          11
        </div>
        <div className="relative flex w-6 justify-center text-center font-primary text-600 font-normal leading-[1.21] text-grey-300">
          <img
            src={heart}
            alt="<3"
            className={`absolute top-1/2 hidden h-[27.47px] min-w-[31.67px] flex-none -translate-y-1/2 transform`}
          />
          12
        </div>
        <div className="relative flex w-6 justify-center text-center font-primary text-600 font-normal leading-[1.21] text-grey-300">
          <img
            src={heart}
            alt="<3"
            className={`absolute top-1/2 hidden h-[27.47px] min-w-[31.67px] flex-none -translate-y-1/2 transform`}
          />
          13
        </div>
        <div className="relative flex w-6 justify-center text-center font-primary text-600 font-normal leading-[1.21] text-grey-300">
          <img
            src={heart}
            alt="<3"
            className={`absolute top-1/2 hidden h-[27.47px] min-w-[31.67px] flex-none -translate-y-1/2 transform`}
          />
          14
        </div>
        <div className="relative flex w-6 justify-center text-center font-primary text-600 font-normal leading-[1.21] text-grey-300">
          <img
            src={heart}
            alt="<3"
            className={`absolute top-1/2 hidden h-[27.47px] min-w-[31.67px] flex-none -translate-y-1/2 transform`}
          />
          15
        </div>
        <div className="relative flex w-6 justify-center text-center font-primary text-600 font-normal leading-[1.21] text-grey-300">
          <img
            src={heart}
            alt="<3"
            className={`absolute top-1/2 hidden h-[27.47px] min-w-[31.67px] flex-none -translate-y-1/2 transform`}
          />
          16
        </div>
        <div className="relative flex w-6 justify-center text-center font-primary text-600 font-normal leading-[1.21] text-grey-300">
          <img
            src={heart}
            alt="<3"
            className={`absolute top-1/2 hidden h-[27.47px] min-w-[31.67px] flex-none -translate-y-1/2 transform`}
          />
          17
        </div>
        <div className="relative flex w-6 justify-center text-center font-primary text-600 font-normal leading-[1.21] text-grey-300">
          <img
            src={heart}
            alt="<3"
            className={`absolute top-1/2 hidden h-[27.47px] min-w-[31.67px] flex-none -translate-y-1/2 transform`}
          />
          18
        </div>
        <div className="relative flex w-6 justify-center text-center font-primary text-600 font-normal leading-[1.21] text-grey-300">
          <img
            src={heart}
            alt="<3"
            className={`absolute top-1/2 hidden h-[27.47px] min-w-[31.67px] flex-none -translate-y-1/2 transform`}
          />
          19
        </div>
        <div className="relative flex w-6 justify-center text-center font-primary text-600 font-normal leading-[1.21] text-grey-300">
          <img
            src={heart}
            alt="<3"
            className={`absolute top-1/2 hidden h-[27.47px] min-w-[31.67px] flex-none -translate-y-1/2 transform`}
          />
          20
        </div>
        <div className="relative flex w-6 justify-center text-center font-primary text-600 font-normal leading-[1.21] text-grey-300">
          <img
            src={heart}
            alt="<3"
            className={`absolute top-1/2 hidden h-[27.47px] min-w-[31.67px] flex-none -translate-y-1/2 transform`}
          />
          21
        </div>
        <div className="relative flex w-6 justify-center text-center font-primary text-600 font-normal leading-[1.21] text-grey-300">
          <img
            src={heart}
            alt="<3"
            className={`absolute top-1/2 hidden h-[27.47px] min-w-[31.67px] flex-none -translate-y-1/2 transform`}
          />
          22
        </div>
        <div className="relative flex w-6 justify-center text-center font-primary text-600 font-normal leading-[1.21] text-grey-300">
          <img
            src={heart}
            alt="<3"
            className={`absolute top-1/2 hidden h-[27.47px] min-w-[31.67px] flex-none -translate-y-1/2 transform`}
          />
          23
        </div>
        <div className="relative flex w-6 justify-center text-center font-primary text-600 font-normal leading-[1.21] text-grey-300">
          <img
            src={heart}
            alt="<3"
            className={`absolute top-1/2 hidden h-[27.47px] min-w-[31.67px] flex-none -translate-y-1/2 transform`}
          />
          24
        </div>
        <div className="relative flex w-6 justify-center text-center font-primary text-600 font-normal leading-[1.21] text-grey-300">
          <img
            src={heart}
            alt="<3"
            className={`absolute top-1/2 hidden h-[27.47px] min-w-[31.67px] flex-none -translate-y-1/2 transform`}
          />
          25
        </div>
        <div className="relative flex w-6 justify-center text-center font-primary text-600 font-normal leading-[1.21] text-grey-300">
          <img
            src={heart}
            alt="<3"
            className={`absolute top-1/2 hidden h-[27.47px] min-w-[31.67px] flex-none -translate-y-1/2 transform`}
          />
          26
        </div>
        <div className="relative flex w-6 justify-center text-center font-primary text-600 font-normal leading-[1.21] text-grey-300">
          <img
            src={heart}
            alt="<3"
            className={`absolute top-1/2 hidden h-[27.47px] min-w-[31.67px] flex-none -translate-y-1/2 transform`}
          />
          27
        </div>
        <div className="relative flex w-6 justify-center text-center font-primary text-600 font-normal leading-[1.21] text-grey-300">
          <img
            src={heart}
            alt="<3"
            className={`absolute top-1/2 hidden h-[27.47px] min-w-[31.67px] flex-none -translate-y-1/2 transform`}
          />
          28
        </div>
        <div className="relative flex w-6 justify-center text-center font-primary text-600 font-normal leading-[1.21] text-grey-300">
          <img
            src={heart}
            alt="<3"
            className={`absolute top-1/2 hidden h-[27.47px] min-w-[31.67px] flex-none -translate-y-1/2 transform`}
          />
          29
        </div>
        <div className="relative flex w-6 justify-center text-center font-primary text-600 font-normal leading-[1.21] text-grey-300">
          <img
            src={heart}
            alt="<3"
            className={`absolute top-1/2 hidden h-[27.47px] min-w-[31.67px] flex-none -translate-y-1/2 transform`}
          />
          32
        </div>
        <div className="relative flex w-6 justify-center text-center font-primary text-600 font-normal leading-[1.21] text-grey-300">
          <img
            src={heart}
            alt="<3"
            className={`absolute top-1/2 hidden h-[27.47px] min-w-[31.67px] flex-none -translate-y-1/2 transform`}
          />
          31
        </div>
      </div>
    </div>
  );
};

export default Date;
